/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Tile_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"Info_viewer">;
    readonly " $refType": "Tile_viewer";
};
export type Tile_viewer$data = Tile_viewer;
export type Tile_viewer$key = {
    readonly " $data"?: Tile_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Tile_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Tile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": "0"
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Info_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = '381fd4365dcbc65fbc1eb6f445ad1617';
export default node;
